// Widget Scripts
import cardWidgetHeaderLogo from "./js/widgets/cardWidgetHeaderLogo.js";
import swiperWidget from "./js/widgets/swiperWidget.js";
import cardWidgetSEOText from "./js/widgets/cardWidgetSEOText.js";
import cardWidgetImageCards from "./js/widgets/cardWidgetImageCards.js";
import videoWidget from "./js/widgets/videoWidget.js";
import * as socialNetworkWidget from "./js/widgets/socialNetworkWidget.js";
import cardWidgetImageButtons from "./js/widgets/cardWidgetImageButtons.js";
import multiScheduleFeature from "./js/widgets/multiScheduleFeature.js";
import cardWidgetFooterImage from "./js/widgets/cardWidgetFooterImage.js";

// Custom Theme Scripts
import "./js/localjs.js";

// Initialize Homepage Widgets
if (window.location.pathname === "/") {
  $(document).ready(function () {
    swiperWidget();
    cardWidgetSEOText();
    multiScheduleFeature();
    cardWidgetImageCards();
    cardWidgetImageButtons();
  });
  $(window).load(function () {
    videoWidget();
    socialNetworkWidget.facebookfeed(true);
    socialNetworkWidget.instafeed(true);
  });
}

$(document).ready(function () {
  cardWidgetHeaderLogo();
  cardWidgetFooterImage();
});
